import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';

export const MyListPage = styled.div`
  padding-top: 24px;

  &.MyListPage-global-nav {
    padding-top: 0;
  }
`;

export const MyListPageTitle = styled.div`
  margin: auto;
  max-width: 272px;
  padding: 8px 0px;

  @media ${viewports['lg-and-up']} {
    max-width: 100%;
  }
`;

export const MyListPageDescription = styled.div`
  margin: auto;
  max-width: 272px;
  padding: 8px 0px;

  @media ${viewports['lg-and-up']} {
    max-width: 334px;
  }
`;

export const MyListPageSortButton = styled.div`
  width: 164px;
  padding-bottom: 16px;

  &.UserItemsPage-sort-dropdown-lg {
    width: 256px;
  }
`;
